import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useRef, useState } from 'react';
import RemoveIcon from '../../assets/icons/close.svg';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../store';
import { setIsModalOpen, setModalContent, setModalContentProps } from '../../store/slices/global';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import Input from '../../ui/Input';
import Button from '../../ui/Button';
import { generatePassword } from '../../helpers';
const FileUploader = ({ onChange, error, errorMessage, accept, buttonLabel, label, maxFileSizeMB, id, }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const fileInputRef = useRef(null);
    const [selectedFileName, setSelectedFileName] = useState(null);
    const handleChange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) {
            onChange(null);
            setSelectedFileName(null);
            return;
        }
        if (maxFileSizeMB && file.size > maxFileSizeMB * 1024 * 1024) {
            onChange(null);
            event.currentTarget.value = '';
            setSelectedFileName(null);
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.cannotUploadFile.key));
            dispatch(setModalContentProps({ maxSize: maxFileSizeMB }));
        }
        else {
            onChange(file);
            setSelectedFileName(file.name);
        }
    };
    const handleDelete = () => {
        fileInputRef.current.value = '';
        onChange(null);
        setSelectedFileName(null);
    };
    return (_jsxs("div", { className: "uploader", children: [label && _jsx("div", { className: "label", children: label }), _jsxs("div", { className: "uploader-wrapper", children: [_jsxs("div", { className: "uploader-input", children: [_jsx("input", { ref: fileInputRef, type: "file", accept: accept, onChange: handleChange, id: id }), _jsx(Input, { id: generatePassword(10), value: selectedFileName || '', placeholder: t('label.no_file_selected'), readOnly: true, additionalContent: selectedFileName ? (_jsx(Button, { shape: 'square', icon: _jsx(RemoveIcon, {}), iconSize: 'small', onClick: handleDelete })) : (_jsx("label", { htmlFor: id, className: "button-filled--primary", children: buttonLabel })) })] }), error && errorMessage && _jsx("div", { className: "form-field-error-message", children: errorMessage })] })] }));
};
export default FileUploader;
